module.exports = __webpack_public_path__ + "img/logo-vertical.ad3e6d53.png";